<template lang="pug">
div
  ul.list-unstyled.filter_group_items.alphabetical
    li(v-for="characterLetter in characters")
      .form-check-alphabetical
        label.box-alphabetical(
          :key="characterLetter + '_letter'"
          :id = "characterLetter.letter"
          @click = "updateSelectedLetter(characterLetter)",
          :class = "letterFieldClass(characterLetter)"
        ) {{ characterLetter.letter }}
</template>

<script>

export default({
  name: 'forms-letter-selector-vue',
  props: {
    characters: { type: Array, default: [] },
    preSelectedLetter: { type: String, default: '' },
    allow_click_on_empty_letter: { type: Boolean, default: false }
  },
  data(){
    return {
      selectedLetter: this.preSelectedLetter
    }
  },
  methods: {
    updateSelectedLetter(letter){
      if (!letter.has_results && !this.allow_click_on_empty_letter) {
        return null
      }
      if (this.selectedLetter == letter.letter) {
        this.setLetter('')
      }
      else {
        this.setLetter(letter.letter)
      }
      this.$emit("update_letter", this.selectedLetter)
    },
    setLetter(letter) {
      this.selectedLetter = letter
    },
    letterFieldClass(letter){
      var class_name=""
      if (this.selectedLetter == letter.letter)
        class_name += " active"
      if (!letter.has_results)
        class_name += " disabled"
      if (this.allow_click_on_empty_letter) {
        class_name += " allowed"
      }
      return class_name
    }
  },
  watch: {
    preSelectedLetter(value){
      this.setLetter(value)
    }
  }
})
</script>
